<template>
  <div v-if="!isCompleted()">
    <div class="text-center mb-3">
      Profile Completeness {{ currentValue }}%
      <template v-if="!hasVerifiedEmail && !resent">
        <a href="#" @click.prevent="resend()">
          (resend email verification)
        </a>
      </template>
      <template v-else-if="!hasVerifiedEmail && resent">
        (verification email resent)
      </template>
      <template v-else-if="!hasPassedAppropriateness">
        <a href="#" @click.prevent="$modal.show('#appropriatenessModal')">
          (complete profile)
        </a>
      </template>
      <template v-else-if="!hasPassedKyc">
        <router-link :to="{ name: 'kyc.provide' }">
          (complete profile)
        </router-link>
      </template>
    </div>
    <div class="progress">
      <div
        class="progress-bar bg-primary"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="getStyle"
        :aria-valuenow="currentValue" />
    </div>
    <div class="row text-center mt-2">
      <div class="col-12 col-sm-4" :class="{ 'font-weight-semibold': hasVerifiedEmail }">
        Email Verification <base-icon :class="{ 'text-success': hasVerifiedEmail }" :icon="hasVerifiedEmail ? 'check' : 'times'" />
      </div>
      <div class="col-12 col-sm-4" :class="{ 'font-weight-semibold': hasPassedAppropriateness }">
        Appropriateness Test <base-icon :class="{ 'text-success': hasPassedAppropriateness }" :icon="hasPassedAppropriateness ? 'check' : 'times'" />
      </div>
      <div class="col-12 col-sm-4" :class="{ 'font-weight-semibold': hasPassedKyc }">
        KYC <base-icon :class="{ 'text-success': hasPassedKyc }" :icon="hasPassedKyc ? 'check' : 'times'" />
      </div>
    </div>
    <appropriateness-modal />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import AppropriatenessModal from './AppropriatenessModal.vue'

export default {
  name: 'ProfileCompleteness',

  components: {
    AppropriatenessModal
  },

  data: () => ({
    resent: false
  }),

  computed: {
    currentValue () {
      const { hasVerifiedEmail, hasPassedAppropriateness, hasPassedKyc } = this
      let value = 0

      if (hasVerifiedEmail) value += 30
      if (hasPassedAppropriateness) value += 35
      if (hasPassedKyc) value += 35

      return value
    },

    getStyle () {
      return {
        width: `${this.currentValue}%`
      }
    },

    hasVerifiedEmail () {
      return this.$auth.user.hasVerifiedEmail
    },

    hasPassedAppropriateness () {
      return this.$auth.user.hasPassedAppropriateness
    },

    hasPassedKyc () {
      return this.$auth.user.hasPassedKyc
    }
  },

  methods: {
    completeProfile () {
      const value = this.currentValue

      if (value === 30) {
        this.$modal.show('#appropriatenessModal')
      } else if (value === 65) {
        this.$router.push({ name: 'kyc.provide' })
      }
    },

    isCompleted () {
      return this.currentValue === 100
    },

    resend () {
      this.resent = true

      this.resendEmailVerification()
    },

    ...mapActions({
      resendEmailVerification: 'core/users/resend-email-verification'
    })
  }
}
</script>
